export default __webpack_public_path__ + "static/media/Vector.0a9fa509.svg";